// Scroll on click
const tabButtons = document.querySelectorAll(".newFeatured-tab-button");
const tabPanes = document.querySelectorAll(".newFeatured-tab-pane");
const tabContainer = document.querySelector(".newFeatured-tabs");

// Display all panes
tabPanes.forEach((pane) => {
  pane.style.display = "block";
});

// Click event to scroll to the pane and adjust tab bar scroll
let lastScrollPosition = window.scrollY;

tabButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const tabId = this.dataset.tab;
    const targetPane = document.getElementById(tabId);

    if (targetPane) {
      const paneOffsetTop =
        targetPane.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 80;
      const titleElement = targetPane.querySelector(
        "h3, .main-collection-title"
      );
      const titleHeight = titleElement ? titleElement.offsetHeight : 0;

      const currentScrollPosition = window.scrollY;
      const isScrollingUp = paneOffsetTop < currentScrollPosition;

      const extraOffset = isScrollingUp ? titleHeight + 30 : 0;

      window.scrollTo({
        top: paneOffsetTop - headerOffset - extraOffset,
        behavior: "smooth",
      });

      lastScrollPosition = currentScrollPosition;
    }

    tabButtons.forEach((btn) => btn.classList.remove("active"));
    this.classList.add("active");

    this.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  });
});

// Scroll event to update active class
window.addEventListener("scroll", () => {
  tabPanes.forEach((pane, index) => {
    const paneTop = pane.getBoundingClientRect().top;
    const paneBottom = pane.getBoundingClientRect().bottom;
    const headerOffset = 150;

    if (paneTop <= headerOffset && paneBottom > headerOffset) {
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabButtons[index].classList.add("active");

      tabButtons[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  });
});

// Sticky Tabs
let lastScrollTop = 0;
const tabs = document.querySelector(".newFeatured-tabs");

window.addEventListener("scroll", function () {
  let scrollTop = window.scrollY;

  const isMobile = window.innerWidth <= 768;
  const mobileTop = "95px";
  const desktopTop = "95px";

  const mobileShowAtScroll = 700;
  const desktopShowAtScroll = 1200;
  const showAtScroll = isMobile ? mobileShowAtScroll : desktopShowAtScroll;

  if (scrollTop > showAtScroll) {
    tabs.style.display = "flex";
    if (scrollTop < lastScrollTop) {
      tabs.style.top = isMobile ? mobileTop : desktopTop;
    } else {
      tabs.style.top = "0px";
    }
  } else {
    tabs.style.display = "none";
  }

  lastScrollTop = scrollTop;
});

// Quantity Increase/Decrease
document.querySelectorAll(".plus-btn").forEach((button) => {
  button.addEventListener("click", function () {
    const quantityInput =
      this.closest(".add-to-cart-form").querySelector("#quantity");
    quantityInput.value = parseInt(quantityInput.value) + 1;
  });
});
document.querySelectorAll(".minus-btn").forEach((button) => {
  button.addEventListener("click", function () {
    const quantityInput =
      this.closest(".add-to-cart-form").querySelector("#quantity");
    if (parseInt(quantityInput.value) > 1) {
      quantityInput.value = parseInt(quantityInput.value) - 1;
    }
  });
});

// atc btn
let atcBtn = document.getElementsByClassName("custom-atc");
let cartDrawer = document.getElementById("site-cart-sidebar");
for (let i = 0; i < atcBtn.length; i++) {
  let current = atcBtn[i];
  current.addEventListener("click", (e) => {
    e.preventDefault();
    addtocartProduct(e);
  });
}
function addtocartProduct(e) {
  let atcBtn = e.target;
  let parentEle = atcBtn.closest("#add-to-cart-form");
  console.log(parentEle);
  let productId = parentEle.querySelector("#productId");
  let cartIcon = document.querySelector(".area--cart");
  let quantity = parentEle.querySelector("#quantity");
  let id = productId.value;
  let formData = {
    items: [
      {
        id: id,
        quantity: quantity.value,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      cartIcon.click();
      cartUpdate();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
function cartUpdate() {
  fetch("?section_id=helper-cart")
    .then((response) => response.text())
    .then((text) => {
      const sectionInnerHTML = new DOMParser().parseFromString(
        text,
        "text/html"
      );
      console.log(sectionInnerHTML);
      const cartFormInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
      const cartSubtotalInnerHTML =
        sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;
      const cartItems = document.getElementById("AjaxCartForm");
      cartItems.innerHTML = cartFormInnerHTML;
      cartItems.ajaxifyCartItems();

      document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-count]").textContent;
      });
      document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
        elm.textContent =
          cartItems.querySelector("[data-cart-total]").textContent;
      });

      document.getElementById("AjaxCartSubtotal").innerHTML =
        cartSubtotalInnerHTML;
      if (document.querySelector("[data-js-site-cart-sidebar]")) {
        document.querySelector("[data-js-site-cart-sidebar]").show();
      }

      if (document.querySelector("cart-recommendations")) {
        document.querySelector("cart-recommendations").innerHTML = "";
        document
          .querySelector("cart-recommendations")
          .generateRecommendations();
      }
    });
}

// Image popup
const popup = document.getElementById("image-popup");
const addToCartButtons = document.querySelectorAll(".add-to-cart-button");
const popupImg = document.getElementById("popup-img");
const popupDesc = document.getElementById("popup-description");
const popID = document.querySelector(".popup-id"); 
const quantityInput = document.querySelector(".popup-quantity"); 

document.querySelectorAll(".popup-trigger").forEach((trigger) => {
  trigger.addEventListener("click", function (event) {
    event.preventDefault();
    const imageUrl = this.getAttribute("data-image");
    const imageDesc = this.getAttribute("data-description");
    const productId = this.getAttribute("data-id"); 

    popupImg.src = imageUrl;
    popupDesc.textContent = imageDesc;
   
     if (imageDesc) {
      popupDesc.style.display = "block";
    } else {
      popupDesc.style.display = "none";
    }

    if (popID) {
      popID.value = productId;
    }

    if (quantityInput) {
      quantityInput.value = 1;
    }
    
    popup.style.display = "flex";
    document.body.classList.add("no-scroll");
  });
});

// Close popup when clicking outside
popup.addEventListener("click", function (event) {
  if (event.target === popup) {
    popup.style.display = "none";
    document.body.classList.remove("no-scroll");
  }
});

// Close Popup when clicking "Add to Cart"
addToCartButtons.forEach((button) => {
  button.addEventListener("click", function () {
      setTimeout(() => {
        popup.style.display = "none"; // Close popup
        document.body.classList.remove("no-scroll");
      }, 1000);
    })
});

  
// Dropdown
const hamburgerIcon = document.querySelector(".hamburger-icon");
const dropdownMenu = document.querySelector(".dropdown-collection");
const overlay = document.getElementById("dropdown-overlay");
const closeDropdownBtn = document.querySelector(".close-dropdown");
const buttonDrop = document.querySelectorAll(
  ".dropdown-collection .newFeatured-tab-button"
);

hamburgerIcon.addEventListener("click", function (event) {
  event.stopPropagation();
  dropdownMenu.style.display = "block";
  overlay.style.display = "block";
});

closeDropdownBtn.addEventListener("click", function () {
  dropdownMenu.style.display = "none";
  overlay.style.display = "none";
});

document.addEventListener("click", function (event) {
  if (
    !dropdownMenu.contains(event.target) &&
    !hamburgerIcon.contains(event.target)
  ) {
    dropdownMenu.style.display = "none";
    overlay.style.display = "none"; 
  }
});

overlay.addEventListener("click", function () {
  dropdownMenu.style.display = "none";
  overlay.style.display = "none"; 
});

buttonDrop.forEach((button) => {
  button.addEventListener("click", function () {
    buttonDrop.forEach((button) => button.classList.remove("dropactive"));
    this.classList.add("dropactive");
    dropdownMenu.style.display = "none";
    overlay.style.display = "none";
  });
});